import React from "react";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "../../stylesheets/resource.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Link, Redirect } from "react-router-dom";
import {
	dateCol,
	ticketPriority,
	ticketStatus,
	tableStyle,
	titleAll,
} from "../variables/ListingVariables";
import { CM_APIs } from "./CM_APIs";
import { UserConsumer } from "../../../UserContext";
import Header from "../../timesheetModule/Header";
import { Table } from "../../../components/CustomPaginations";
import { statusColor } from "../../../components/TableStyle";
import { GlobalPaginationSize } from "../../../components/GlobalPaginationSize";
import { Routes } from "../../../configurations/config";
let token = null;
class CountryManagerTicketListing extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			title: "View Assigned tickets",
			error: null,
			isLoaded: false,
			items: [],
			toggledClearRows: false,
			tableLoader: false,
			currentPage: 1,
			pageNum: 1,
			numberOfItemsPerPage: GlobalPaginationSize.CMPaginationSize,
			pagerData: [],
			sortBy: {
				dataField: "ticketId",
				order: "desc",
			},
			searchInput: "",
		};
		this.input = React.createRef();
	}
	defaultSorted = [
		{
			dataField: "ticketId",
			order: "desc",
		},
	];
	getColumns = () => {
		return [
			{
				dataField: "ticketId",
				text: "Ticket ID",
				sort: true,
				headerStyle: {
					width: "10%",
				},
			},
			{
				dataField: "itemName",
				text: "Item Name",
				sort: true,
				formatter: (cell, row) => {
					if (row.itemName === null) {
						return row.alternateTicketItem;
					} else {
						return row.itemName;
					}
				},
				headerStyle: {
					width: "15%",
				},
			},
			{
				dataField: "creator",
				text: "Created By",
				sort: true,
				headerStyle: {
					width: "13%",
				},
			},
			{
				dataField: "department",
				text: "Department",
				sort: true,
				formatter: (cell, row) => {
					const title = row.assignee;
					return <div title={title}>{row.department}</div>;
				},
				headerStyle: {
					width: "12%",
				},
			},
			{
				dataField: "priority",
				text: "Priority",
				formatter: ticketPriority,
				headerStyle: {
					width: "9%",
				},
			},
			{
				dataField: "status",
				text: "Status",
				formatter: ticketStatus,
				style: (cell, row) => {
					return statusColor(ticketStatus(row.status));
				},
				headerStyle: {
					width: "10%",
				},
			},
			{
				dataField: "expectedDate",
				text: "Due Date",
				sort: true,
				formatter: dateCol,
				headerStyle: {
					width: "11%",
				},
			},
			{
				dataField: "link",
				text: "Action",
				formatter: (cell, row, e) => {
					return (
						<div>
							<Link
								to={{
									pathname: `${Routes.TicketDetails}/${row.ticketId}`,
									state: {
										currentPage: this.state.currentPage,
										redirectUrl: Routes.CMTicketListing,
									},
								}}
							>
								<button
									className="btnStyle"
									title="View Detail"
								>
									<FontAwesomeIcon
										id="edit"
										className="hoverEffect"
										icon={faEye}
										size="1x"
									/>
								</button>
							</Link>
						</div>
					);
				},
				headerStyle: {
					width: "7%",
				},
			},
		];
	};
	componentDidMount() {
		const { history } = this.props;
		history && history.replace();
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		this.setState({ tableLoader: true }, () => {
			axios
				.get(
					`${CM_APIs.CMTicketListing_API}?Page=${this.state.pageNum}&PageSize=${this.state.numberOfItemsPerPage}&SortBy=${this.state.sortBy.dataField}_${this.state.sortBy.order}`,
					{ headers: headers }
				)
				.then((res) => {
					const items = res.data.ticketResponses;
					this.setState({
						items,
						tableLoader: !this.state.tableLoader,
						pagerData: JSON.parse(res.headers["x-pagination"]),
					});
				});
		});
	}
	SearchBar = () => {
		const handleClick = (e) => {
			const value = this.input.value;
			this.setState({
				input: value,
				searchInput: value,
			});
			const headers = {
				Authorization: `Bearer ${token}`,
			};

			if (value === "") {
				this.setState({ tableLoader: true }, () => {
					axios
						.get(
							`${
								CM_APIs.CMTicketListing_API
							}?Page=${1}&PageSize=${
								this.state.numberOfItemsPerPage
							}&SortBy=${this.state.sortBy.dataField}_${
								this.state.sortBy.order
							}`,
							{ headers: headers }
						)
						.then((res) => {
							const items = res.data.ticketResponses;
							this.setState({
								items,
								pageNum: 1,
								tableLoader: false,
								pagerData: JSON.parse(
									res.headers["x-pagination"]
								),
							});
						});
				});
				this.setState({
					tableLoader: false,
				});
			} else {
				this.setState({ tableLoader: true }, () => {
					axios
						.get(
							`${
								CM_APIs.CMTicketListing_API
							}?Page=${1}&PageSize=${
								this.state.numberOfItemsPerPage
							}&SortBy=${this.state.sortBy.dataField}_${
								this.state.sortBy.order
							}&SearchTerm=${value}`,
							{ headers: headers }
						)
						.then((res) => {
							const items = res.data.ticketResponses;
							this.setState({
								items,
								pageNum: 1,
								tableLoader: false,
								pagerData: JSON.parse(
									res.headers["x-pagination"]
								),
							});
						});
				});
			}
		};
		return (
			<div className="col-lg-3 mb-2">
				<input
					className="form-control resourceTickets-SearchBar"
					ref={(n) => (this.input = n)}
					type="text"
					onChange={handleClick}
					onFocus={() => this.setState({ currentPage: 1 })}
					placeholder="Search"
				/>
			</div>
		);
	};
	static getDerivedStateFromProps(nextProps, prevState) {
		return {
			currentPage:
				nextProps.history &&
				nextProps.history.location &&
				nextProps.history.location.state
					? nextProps.history.location.state.currentPage
					: prevState.currentPage,
		};
	}

	receiveData = (PageSize) => {
		axios
			.get(
				`${
					CM_APIs.CMTicketListing_API
				}?Page=${1}&PageSize=${PageSize}&SortBy=${
					this.state.sortBy.dataField
				}_${this.state.sortBy.order}${
					this.input.value ? "&SearchTerm=" + this.input.value : ""
				}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				let items = res.data.ticketResponses;
				if (res.status === 200) {
					this.setState({
						pageNum: 1,
						numberOfItemsPerPage: PageSize,
						pagerData: JSON.parse(res.headers["x-pagination"]),
						items: items,
					});
				}
			});
	};
	handleTableChange = (type, { page, sortOrder, sortField }) => {
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${CM_APIs.CMTicketListing_API}?Page=${page}&PageSize=${
				this.state.numberOfItemsPerPage
			}&SortBy=${sortField}_${sortOrder}${
				this.input.value ? "&SearchTerm=" + this.input.value : ""
			}`;
			this.setState({
				sortBy: { dataField: sortField, order: sortOrder },
			});
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${CM_APIs.CMTicketListing_API}?Page=${page}&PageSize=${
				this.state.numberOfItemsPerPage
			}&SortBy=${this.state.sortBy.dataField}_${this.state.sortBy.order}${
				this.input.value ? "&SearchTerm=" + this.input.value : ""
			}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					let items = res.data.ticketResponses;
					if (res.status === 200) {
						this.setState({
							pageNum: page,
							pagerData: JSON.parse(res.headers["x-pagination"]),
							items: items,
						});
					}
				});
		}
	};
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					return userDetails.designation.toString() === "4" ? (
						<div className="container-fluid pl-3 pr-3">
							<Header title={titleAll(userDetails)} />
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: this.state.pagerData
										? this.state.pagerData.TotalCount
										: 0,
									page: this.state.pageNum,
									sizePerPage:
										this.state.numberOfItemsPerPage,
									paginationSize:
										this.state.numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											columns={this.getColumns()}
											items={this.state.items}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												this.handleTableChange
											}
											defaultSorted={this.defaultSorted}
											tableLoader={this.state.tableLoader}
											SearchBar={this.SearchBar}
											inputValue={this.input.value}
											keyField="ticketId"
											receiveData={(PageSize) => {
												this.receiveData(PageSize);
											}}
											pagerData={this.state?.pagerData}
											rowEvents={{
												onClick: (e, row) => {
													this.props.history.push({
														pathname: `${Routes.TicketDetails}/${row.ticketId}`,
														state: {
															currentPage:
																this.state
																	.currentPage,
															redirectUrl:
																Routes.CMTicketListing,
														},
													});
												},
											}}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					) : (
						<Redirect to="/MyDashboard" />
					);
				}}
			</UserConsumer>
		);
	}
}

export default CountryManagerTicketListing;
